import { FileData, MeshCategory,MESH_CATEGORIES } from "../../data/data-interfaces.internal.ts";
export function isMeshPart(file: FileData): file is FileData & { category: MeshCategory } {
  return (MESH_CATEGORIES as readonly string[]).includes(file.category);
}

export function sidecarBuffer(customData: object): Promise<ArrayBuffer> {
  return new Blob([JSON.stringify(customData, null, 2)], { type: 'application/json' }).arrayBuffer();
}
